import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchAppToken } from '../actions/app_token'
import AbstractPage from "./AbstractPage";
import toastr from 'toastr'

class Login extends AbstractPage {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: ""
    };
    this.title = "Anglo iForm";
  }

  componentWillReceiveProps(nextProps) {
    if(nextProps.loginFailure) {
      toastr.error('Invalid Email or password.', 'Login Error!')
    }
  }

  render() {
    return (
      <div className="layout-content">
        <div className="container-fluid col-md-3 login-form">
          <div className="form-group">
            <label>Email address</label>
            <input
              type="text"
              className="form-control"
              placeholder="Email address"
              onChange={ event => this.setState({username: event.target.value}) }
            />
          </div>
          <div className="form-group">
            <label>Password</label>
            <input
              type="password"
              className="form-control"
              placeholder="Password"
              onChange={ event => this.setState({password: event.target.value}) }
            />
          </div>
          <button className="btn btn-primary" onClick={ () => this.props.login(this.state) }>
            Submit
          </button>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    token: state.app_token.accessToken,
    loading: state.app_token.loading,
    loginSuccess: state.app_token.loginSuccess,
    loginFailure: state.app_token.loginFailure,
    pending: state.app_token.pending,
    signedIn: state.app_token.signedIn
  };
};

const mapDispatchToProps = dispatch => {
  return {
    login: (localState) => {
      var { username, password, grant_type } = localState;
      dispatch(fetchAppToken({username, password, grant_type }))
    },
  };
};

let LoginPage = connect(mapStateToProps, mapDispatchToProps)(Login)
export default LoginPage;



// WEBPACK FOOTER //
// ./src/views/login.js